export default __webpack_public_path__ + "static/media/pdfIcon.36277bb2.svg";